import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './MainPage';
import BrandOnboardingForm from './BrandOnboardingForm';
import ProductOnboardingForm from './ProductOnboardingForm';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        {/* Shopify routes */}
        <Route path="/shopify/brand-onboarding" element={<BrandOnboardingForm platform="shopify" />} />
        <Route path="/shopify/product-onboarding" element={<ProductOnboardingForm platform="shopify" />} />
        {/* Non-Shopify routes */}
        <Route path="/non-shopify/brand-onboarding" element={<BrandOnboardingForm platform="non-shopify" />} />
        <Route path="/non-shopify/product-onboarding" element={<ProductOnboardingForm platform="non-shopify" />} />
        {/* Legacy routes for backward compatibility */}
        <Route path="/brand-onboarding" element={<BrandOnboardingForm />} />
        <Route path="/product-onboarding" element={<ProductOnboardingForm />} />
      </Routes>
    </Router>
  );
}

export default App;